var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.55 15.5 3.29-5.245a1 1 0 0 0-.105-1.22l-.55-.615c2.67-3.315 3.465-6.72 2.28-7.905-1.185-1.185-4.59-.37-7.905 2.3l-.615-.55a1 1 0 0 0-1.22-.105L.5 5.45a1 1 0 0 0 .085 1.775l2.175 1.09a3.29 3.29 0 0 0-.17 1A3.89 3.89 0 0 0 3.93 12.1a3.89 3.89 0 0 0 2.785 1.34 3.29 3.29 0 0 0 1-.17l1.09 2.175a1 1 0 0 0 1.745.055Zm-.895-9.155a2.09 2.09 0 1 1 2.95-2.961 2.09 2.09 0 0 1-2.95 2.961Z"
  })));
};
export default SvgRocket;